import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-scroll";
import { slide as Menu } from 'react-burger-menu';
import LogoShe from "../../img/she-logo-new.svg";

function Header() {
    const buttonClick = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'button_click',
        });
    };

    const [menuState, setMenuState] = useState();
    const [offset, setOffset] = useState(0);

    // Тексты сразу на украинском
    const aboutText = 'Про івент';
    const joinText = 'Взяти участь';
    const joinTextMobile = 'Участь';
    const speacersText = 'Спікери';

    useEffect(() => {
        const onScroll = () => setOffset(window.scrollY);
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const isMenuOpen = (state) => state.isOpen;

    useEffect(() => {
        isMenuOpen === false ? setMenuState(true) : setMenuState(false)
    });

    const toggleMenu = () => setMenuState(true);

    return (
        <header
                className={
                    offset >= 200
                        ? 'bg-white fixed top-0 left-0 w-full z-40'
                        : 'py-3 bg-white/30 fixed z-[60] top-0 left-0 w-full'
                }
                style={{ transition: '0.5s' }}>

            <div className="py-3 left-0 w-full top-0">
                <div className="container max-w-screen-xl px-3 mx-auto flex justify-between items-center relative">
                    <div
                         className={
                             offset >= 600
                                 ? 'flex gap-4 justify-start items-center sm:w-[150px] w-[100px]'
                                 : 'opacity-0 w-0 absolute -ml-80'
                         }
                         style={{ transition: '0.8s' }} >
                        <a
                            href="/"
                        >
                            <img src={LogoShe} alt="Logo HRWS" className="w-full"/>
                        </a>
                    </div>

                    <div className="block lg:hidden" style={{ transition: '0.5s' }}>
                        <Menu onStateChange={isMenuOpen} isOpen={menuState} pageWrapId={"page-wrap"}>
                            <nav id="page-wrap">
                                <ul className="text-black">
                                    <li className="mb-3">
                                        <Link to="ebaut" onClick={toggleMenu} smooth={true} offset={-70} duration={500}>
                                            {aboutText}
                                        </Link>
                                    </li>
                                    <li className="mb-3">
                                        <Link to="speacers" onClick={toggleMenu} smooth={true} offset={-70}
                                              duration={500}>
                                            {speacersText}
                                        </Link>
                                    </li>
                                    <li className="mb-3">
                                        <Link to="programm" onClick={toggleMenu} smooth={true} offset={-70}
                                              duration={500}>
                                            Програма
                                        </Link>
                                    </li>
                                </ul>
                            </nav>
                        </Menu>
                    </div>

                    <nav className="hidden lg:block" id="page-wrap">
                        <ul className="flex gap-14">
                            <li className="max-sm:hidden">
                                <Link to="ebaut" smooth={true} offset={-70} duration={500}>
                                    {aboutText}
                                </Link>
                            </li>
                            <li>
                                <Link to="speacers" smooth={true} offset={-70} duration={500}>
                                    {speacersText}
                                </Link>
                            </li>
                            <li>
                                <Link to="programm" smooth={true} offset={-70} duration={500}>
                                    Програма
                                </Link>
                            </li>
                        </ul>
                    </nav>

                    <Link
                        to="formats"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        onClick={buttonClick}
                        className="group relative overflow-hidden font-bold uppercase py-2 px-4 inline-flex items-center-to-r bg-[#F5D858] hover:bg-[#F5D858]/60 transition-all ease-in-out duration-300 text-[#245864] border-0">
                        <span className="sm:block hidden">{joinText}</span><span
                        className="sm:hidden block">{joinTextMobile}</span>
                    </Link>

                </div>
            </div>

        </header>
    );
}


export default Header;